import {Grid} from "@mui/material";
import AppLanguageSelect from "../../app-language-select";

const AppLanguageSelectButton = ({viewMode, onNavigate}) => (
  <Grid className="language-btn" display={"flex"} alignItems={"center"}>
    <AppLanguageSelect viewMode={viewMode} onNavigate={onNavigate} />
  </Grid>
);

export default AppLanguageSelectButton;
